<template>
    <div class="">
        <div class="big"  v-if="width >=1200">
            <div style="width:1440px;margin:0 auto;">
                <div class="box">
                    <div class="title">联系方式</div>
                    <div class="line">
                        <div class="bg">{{ list.address }}</div>
                        <div class="bg">联系方式：{{ list.phone }}</div>
                        <div class="bg">服务直通热线：{{ list.marketHotLine }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="small" v-else>
            <div class="box">
                    <div class="title">联系方式</div>
                    <div class="line">
                        <div class="bg">{{ list.address }}</div>
                        <div class="bg">联系方式：{{ list.phone }}</div>
                        <div class="bg">服务直通热线：{{ list.marketHotLine }}</div>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
import { getSite } from '../api/api'
export default {
    data () {
        return {
            list:{},
            width:document.documentElement.clientWidth
        }
    },
   mounted () {
     window.onresize = () => {
       return (() => {
         this.width = document.documentElement.clientWidth // 宽
       })()
     }
    getSite().then(res => {
        // console.log(res,'rrrrr');
        this.list = res.data.data
    })
   }

}
</script>

<style lang="scss" scoped>
    @media (min-width:1200px) {
        .big{
        width: 100%;
        //height: 238px;
        background: url('../assets/img/contact.png') no-repeat;
        background-size: 100% 100%;
          padding-bottom: 15px;
        box-sizing: border-box;
        .box{
            width: 100%;
            height: 100%;
        }
        .title{
            font-size: 24px;
            font-weight: normal;
            padding-top: 30px;
            margin-bottom: 50px;
            box-sizing: border-box;
            letter-spacing: 0px;
            color: #383838;
        }
        .line{
            width: 88%;
            //display: flex;
            //justify-content: space-between;
            box-sizing: border-box;
            .bg{
                // width: 22%;
                //height: 40px;
              margin-top: 10px;
                line-height: 40px;
                background-color: #fff;
                border-radius: 10px;
                padding: 0 10px;
                box-sizing: border-box;
            }
        }
    }
    }
    @media (max-width:1200px) {
        .small{
            margin-top: 20px;
            width: 100%;
            padding-bottom: 10px;
            //height: 180px;
            background: url('../assets/move/contant.png') no-repeat;
            background-size: 100% 100%;
        }
        .box{
            width: 100%;
            height: 100%;
        }
        .title{
            font-size: 14px;
            font-weight: 700;
            padding-top: 20px;
            margin-left: 30px;
            // margin-bottom: 50px;
            box-sizing: border-box;
            letter-spacing: 0px;
            color: #383838;
        }
        .line{
            width: 100%;
            display: flex;
            flex-direction: column;
            // justify-content: center;
            align-items:  space-around;
            // justify-content: space-between;
            box-sizing: border-box;
            font-size: 12px;
            font-weight: 600;
            padding: 0 5%;
            // margin-left: 5%;
            .bg{
                // width: 22%;
                //height: 30px;
                line-height: 30px;
                background-color: #fff;
                border-radius: 10px;
                padding: 0 10px;
                margin-top: 10px;
                box-sizing: border-box;
            }
        }
    }
</style>
